export class Empresa {
    public id: number;
    public nombre: string;
    public razonSocial: string;
    public rfc: string;
    public colorPrimario: string;
    public colorSecundario: string;
    public colorAcento: string;
    public logoPrincipal: string;
    public logoLogin: string;
    public fechaRegistro: Date;
    public fechaInicioContrato: Date;
    public fechaFinContrato: Date;
    public fechaRenovacionContrato: Date;
    public mesesRenovacionContrato: number;
    public renovarContrato: boolean;
    public activo: boolean;

    constructor() {
        this.id = 0;
        this.nombre = "";
        this.razonSocial = "";
        this.rfc = "";
        this.colorPrimario = "#1f6feb";
        this.colorSecundario = "#111827";
        this.colorAcento = "#f59e0b";
        this.logoPrincipal = "";
        this.logoLogin = "";
        this.fechaRegistro = new Date();
        this.fechaInicioContrato = new Date();
        this.fechaFinContrato = new Date();
        this.fechaRenovacionContrato = new Date();
        this.mesesRenovacionContrato = 1;
        this.renovarContrato = false;
        this.activo = true;
    }
}

